export { default as CircleChevron } from './CircleChevron'
export { default as YellowCircleChevron } from './YellowCircleChevron'



// WEBPACK FOOTER //
// ./src/core/icons/CircleChevron/index.js